import { Step, StepLabel, Stepper } from '@mui/material';
import { useBookingFlowContext } from './BookingFlowProvider';

export function BookingFlowStepper() {
  const { steps, stepIndex } = useBookingFlowContext();
  return (
    <Stepper activeStep={stepIndex} alternativeLabel sx={{ mb: 3 }}>
      {steps.map((step) => (
        <Step key={step.id}>
          <StepLabel>{step.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
